import { COLORS_CONFIG, DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'
import { CommonWidgetParams, getCommonWidget } from '../dashWidgetHelper'



export const GREEN_1 = '#88DD76'
export const GREEN_2 = '#AEDD76'
export const ORANGE = '#F3AF5A'
export const BLUE = '#8CF0EA'
export const RED_2 = '#DB7476'
export const RED_1 = '#CD4245'
export const YELLOW = '#F1E713'

export const CJ_HONDA_ORDER = {
  106: 0,	// Explicación Trabajo
  1007: 1,	// Entrega
  1006: 2,	// Asesor servicio
  112: 3,	// Facturación
  1: 0,	// Bienvenida
  2: 1,	// Venta Consultiva
  3: 2,	// Prueba de Manejo
  5: 3,	// Financiamiento
  7: 4,	// Seguimiento
  8: 5,	// Entrega
}


export const NETPAY_COLORS_NPS = [
    // '#A2D1A2', // Positivo - verde old
    // '#F5B49F', // Negativo - rojo old
    // '#A3D1D6', // Neutro - azul old
    '#a3d977', // Positivo - verde
    '#f5a524', // amarillo
    '#e74c5c', // Negativo - rojo
    '#8CF0EA', // Neutro - azul
    '#F3AF5A', // Naranja - neutro
    '#B29BC2',
    '#F3B6D8',
    '#FFF9B1',
    '#34C0B8',
    '#FFD01B',
    '#F5B49F',
    '#777933',
    '#A668A8',
    '#9A9CCD',
    '#9C6D76',
    '#C0CB0B',
    '#878972',
    '#0C84AD',
    '#C357F2',
    '#986CAF',
    // Colores adicionales únicos
    '#22a06b', // VERDE (OXXO_DEFAULT_COLORS)
    '#f08591', // ROJO (OXXO_DEFAULT_COLORS)
    '#0f4026', // VERDE_OSCURO (OXXO_DEFAULT_COLORS)
    '#AEDD76', // GREEN_2
    '#CD4245', // RED_1
    '#F1E713', // YELLOW
    '#88DD76', // GREEN_1
    '#DB7476', // RED_2
    '#B29BC2', // (ya estaba, pero por si acaso)
    '#A3D1D6', // azul old
    '#A2D1A2', // verde old
    '#F5B49F', // rojo old
];

export const NETPAY_DEFAULT_COLORS = {
    ROJO_OSCURO: '#e74c5c',
    ROJO: '#f08591',
    NARANJA: '#f5a524',
    AMARILLO: '#f5a524',
    VERDE_CLARO: '#a3d977',
    VERDE: '#22a06b',
    VERDE_OSCURO: '#0f4026'
}
export const NETPAY_COLORS_STACKED_BAR = {
    1: NETPAY_DEFAULT_COLORS.ROJO_OSCURO,
    2: NETPAY_DEFAULT_COLORS.ROJO,
    3: NETPAY_DEFAULT_COLORS.NARANJA,
    4: NETPAY_DEFAULT_COLORS.AMARILLO,
    5: NETPAY_DEFAULT_COLORS.VERDE_CLARO,
    6: NETPAY_DEFAULT_COLORS.VERDE,
    7: NETPAY_DEFAULT_COLORS.VERDE_OSCURO,
}





export const NETPAY_SCALE_3_COLORS = {
    'promoters': NETPAY_DEFAULT_COLORS.VERDE,
    'passives': NETPAY_DEFAULT_COLORS.AMARILLO,
    'detractors': NETPAY_DEFAULT_COLORS.ROJO_OSCURO,
    'positive': NETPAY_DEFAULT_COLORS.VERDE,
    'neutral': NETPAY_DEFAULT_COLORS.AMARILLO,
    'negative': NETPAY_DEFAULT_COLORS.ROJO_OSCURO,
}

export const OXXO_COLORS_CONFIG_BAR = [
    // Negativo
    {
        color: NETPAY_DEFAULT_COLORS.ROJO_OSCURO,
        condition: '<=' as const,
        key: 'value',
        value: 40,
    },
    // Neutro
    {
        color: NETPAY_DEFAULT_COLORS.AMARILLO,
        condition: '>' as const,
        key: 'value',
        value: 40,
    },
    // Positivo
    {
        color: NETPAY_DEFAULT_COLORS.VERDE,
        condition: '>' as const,
        key: 'value',
        value: 80,
    },
]

export const OXXO_COLORS_CONFIG_SCALE_5 = [
    // Negativo
    {
        color: NETPAY_DEFAULT_COLORS.ROJO_OSCURO,
        condition: '<=' as const,
        key: 'value',
        value: 2,
    },
    // Neutro
    {
        color: NETPAY_DEFAULT_COLORS.AMARILLO,
        condition: '>' as const,
        key: 'value',
        value: 2,
    },
    // Positivo
    {
        color: NETPAY_DEFAULT_COLORS.VERDE,
        condition: '>' as const,
        key: 'value',
        value: 4,
    },
]


export const NETPAY_DEFAULT_SCALE_3_COLORS = {
    'promoters': NETPAY_DEFAULT_COLORS.VERDE,
    'passives': NETPAY_DEFAULT_COLORS.AMARILLO,
    'detractors': NETPAY_DEFAULT_COLORS.ROJO,
    'positive': NETPAY_DEFAULT_COLORS.VERDE,
    'neutral': NETPAY_DEFAULT_COLORS.AMARILLO,
    'negative': NETPAY_DEFAULT_COLORS.ROJO,
}



export const msurPorcRespuestasMapper = (data: any): any => {
  //console.log('porcRespuestasMapper')
  //console.log(data)
  return data !== undefined
    && data[0] !== undefined
    && data[0].resume !== undefined
    ? {
      value: data[0].resume?.answeredPerc,
      processed: data[0].resume?.processed,
      answered: data[0].resume?.answered
    }
    : {}
}

export const msurTooltipTotalRegistros = (data: any) => {
  //console.log('haTooltipTotalRegistros')
  //console.log(data)
  return "Total de envios" + ' ' + data.processed //'Total encuestas ' + data.total
}

export const suzukiCustomerJourneyMapper = (data: any, extra: any) => {
  return data.map((item: any) => {
    return {
      ...item,
      label: 'widgets.indicatorId.' + item.groupId,
      weight: CJ_HONDA_ORDER[item.groupId],
    }
  })// @ts-ignore
    .asMutable()
    .sort((item1: any, item2: any) => item1.weight - item2.weight)
}

export const suzukiCustomPieMapper = (data: any) => {
  return data.map((item: any) => ({
    id: item["group"] == null ? "Indefinido" : item["group"],
    label: item["group"] == null ? "Indefinido" : item["group"],
    value: item["value"],
  }))
}

export const getCmID = (code: string): number => {
  if (code === 'venta') return 10651
  else if (code === 'servicio' || code === 'postventa') return 10652
  else return 1
}

export const HONDA_COLORS_CONFIG = [
  {
    color: RED_1,
    condition: '<=' as const,
    key: 'value',
    value: 40,
  },
  {
    color: ORANGE,
    condition: '>' as const,
    key: 'value',
    value: 40,
  },
  {
    color: GREEN_1,
    condition: '>=' as const,
    key: 'value',
    value: 80,
  },
]

export const commonWidgets: CommonWidget = {
  ...widgetsLibrary,
  multipleGaugeByQuestion: {
    ...widgetsLibrary.multipleGaugeByQuestion,
    //@ts-ignore
    config: {
      ...widgetsLibrary.multipleGaugeByQuestion.config,
      colors: HONDA_COLORS_CONFIG,
      maxValue: 5
    },
  }
}

export const HONDA_SCALE_3_COLORS = {
  'promoters': GREEN_1,
  'passives': ORANGE,
  'detractors': RED_2,
  'positive': GREEN_1,
  'neutral': ORANGE,
  'negative': RED_1,
  1: GREEN_1,
  2: ORANGE,
  3: RED_1,
}

const getCJIndicators = (indicatorsConfig: { [key: string]: any }) => {
  return Object.keys(indicatorsConfig).map(key => ({
    indicator: indicatorsConfig[key].name,
    grouped: undefined,
    keyExtract: ['group', 'value', 'groupId'],
    label: 'group',
    value: 'value',
    singleton: true,
    extras: {
      groupNameFormat: 'description',
      formula: indicatorsConfig[key].formula ?? undefined,
      ...indicatorsConfig[key].extrasFechas ?? undefined
    },
  }));
};
export const getHondaCustomerJourney = (props: {
  id: string
  indicators: { [key: string]: any },
  position?: number[],
  size: number[],
  title?: string,
  helpText?: string,
  extraConfigs?: { [key: string]: any }
}) => {
  const {
    id,
    indicators,
    position,
    size,
    title,
    helpText,
    extraConfigs
  } = props
  return {
    title: title,
    position: position,
    size: size,
    //helpText: helpText ?? 'A excepción del NPS, las métricas mostradas son el TTB respuesta del cliente (porcentaje de menciones para las dos respuestas de mayor valor dentro de la escala)',
    showHelp: true,
    config: {
      id: id,
      type: 'multipleGauge',
      fillMode: '',
      maxValue: 100,
      //colors: COLORS_CONFIG,
      colors: HONDA_COLORS_CONFIG,
      showValues: true,
      showHistoric: false,
      mapper: (data: any, extra: any) => {
        console.log('rendering CJ profuturo!')
        console.log(data)
        console.log(indicators)
        return Object.keys(data).flatMap((key) => {
          const sortedValues = data[key]
            .asMutable()
            .sort((c1: any, c2: any) => c1.groupId - c2.groupId)
            .map((item: any) => {
              const label = indicators
                ?.find((ind: any) => ind.name === key)
                ?.label

              return {
                value: item.value,
                name: key,
                label: label
              }
            });

          const item = sortedValues?.[0]
          const item2 = sortedValues?.[1]
          return item
            ? {
              label: item.label ?? `widgets.indicatorId.${item.name}`,
              value: item2 ? item.value + item2.value : item.value,
              //value: item.value
            }
            : undefined;
        });

      },
      indicators: getCJIndicators(indicators)
    },
  }
}

export const getHondaNpsBar = (props: CommonWidgetParams): Widget => {
  const {
    name,
    commonWidgets,
    title,
    subTitle,
    position,
    size,
    render,
    showSample,
    key,
    indicator,
    mapper,
    tooltipFormatter,
    extraConfigs,
    extraIndicatorConfigs,
    url,
    extras,
    historic,
    helpText,
    parseFilters,
    targetConfig
  } = props;

  const commonWidgetConfig = getCommonWidget(props);

  if (commonWidgetConfig?.config?.indicators) {
    commonWidgetConfig.config.indicators.push(
        {
          indicator: indicator ?? 'FALTA',
          key: "monthlyNps",
          grouped: "formattedMonth",
          //groupNameFormat: "description",
          keyExtract: ['count','detractorCount','detractors','fanCount','fans','group','group_0','group_1','groupId','groupName','passiveCount','passives','promoterCount','promoterNoFanCount','promoters','promotersNoFan','value'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            //formula: indicatorsConfig[key].formula ?? undefined,
            //...indicatorsConfig[key].extrasFechas ?? undefined
            //formula: 'nps-10',
                    //groupByResponseValueId: 13706,//Id de la pregunta
            //groupBy: "responseValue",
            //categories: ['promoters', 'passives', 'detractors'],
          },
      }
    );

    commonWidgetConfig.config.mapper = (data: any, extra: any) => {
      console.log('rendering NPS bar!')
      console.log(data)
      const monthly = data['monthlyNps']
      const question = data['bar-by-question-nps']
      const bars = question ? question.map((item: any) => ({
        ...item,
        group: 'NPS',
        groupName: 'NPS',
        label: 'NPS',

        //group: CLIENT_PROFILE_LABELS[ item.groupId_1 ?? item.groupId], 
        //groupName: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],
        //label: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],

      })) : [];

      const barsQuestion = monthly ? monthly.map((item: any) => ({
        ...item,
        group: item.groupName,
        label: item.groupName,
      })) : [];

      return [...bars, ...barsQuestion];
    };
  }

  return commonWidgetConfig;
}